"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Select = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deprecated = _interopRequireDefault(require("../util/deprecated"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _Field = require("../Field");

var Select =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Select, _React$Component);

  function Select() {
    (0, _classCallCheck2["default"])(this, Select);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Select).apply(this, arguments));
  }

  (0, _createClass2["default"])(Select, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // Cannot use PureRenderMixin because we need deep comparison for props.options
      return !(0, _isEqual2["default"])(nextProps, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          options = _this$props.options,
          optionFormatter = _this$props.optionFormatter,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["children", "options", "optionFormatter"]);
      otherProps = (0, _omit2["default"])(otherProps, 'toolbar');

      if (optionFormatter === undefined) {
        optionFormatter = function optionFormatter(x) {
          return x;
        };
      }

      if (Array.isArray(options)) {
        console.error('Array options to Select are deprecated. Use LogicalSelect instead.');
        var mappedOptions = {};
        options.forEach(function (val) {
          mappedOptions[optionFormatter(val)] = val;
        });
        options = mappedOptions;
      }

      if (options) {
        children = Object.keys(options).map(function (key) {
          var value = options[key];
          return _react["default"].createElement("option", {
            key: key,
            value: value
          }, key);
        }, this);
      }

      return _react["default"].createElement("select", otherProps, children);
    }
  }]);
  return Select;
}(_react["default"].Component);

exports.Select = Select;
Select.displayName = 'SelectField';
Select.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string,
  onChange: _propTypes["default"].func,

  /**
   * pairs of name -> value option elements. Overrides option nodes set as children of the component.
   */
  options: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),

  /**
   * <option value="foo">Foo</option>
   */
  children: _propTypes["default"].node,

  /**
   * When the options prop is an array, format the keys with this function. values remain in original form
   */
  optionFormatter: (0, _deprecated["default"])(_propTypes["default"].func, 'Use LogicalSelect instead'),
  value: _propTypes["default"].any
} : {};
var SelectField = (0, _Field.wrap)(Select);
var _default = SelectField;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/SelectField/index.js
// module id = 352
// module chunks = 0